import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  transition: opacity 0.25s linear;\n  opacity: 1;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  ",
        " {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  &:focus-within {\n    ",
        "\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  cursor: pointer;\n\n  &:hover ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { AspectRatioBox, Box, prefixUrl } from "@miro-site/core";
import { BoardEmbed } from "@miro-site/ui-board-embed";
import TransparentButton from "../../button/TransparentButton";
import { useTranslation } from "next-i18next";
import NextImage from "next/image";
import { Search } from "../../icons/Icons";
var PreviewIcon = styled(Search).withConfig({
    componentId: "sc-8c66e08-0"
})(_templateObject(), function(props) {
    return props.theme.normalizeStyles({
        marginRight: 10
    });
});
var PreviewButton = styled(TransparentButton).attrs({
    $size: "medium"
}).withConfig({
    componentId: "sc-8c66e08-1"
})(_templateObject1(), function(props) {
    return props.theme.colors.primaryWhite;
});
var previewVisibleStyles = css(_templateObject2());
var PreviewContainer = styled(Box).attrs({
    $styles: {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        transition: "opacity 0.25s linear",
        opacity: 0,
        background: "rgba(5, 0, 56, 0.2)"
    }
}).withConfig({
    componentId: "sc-8c66e08-2"
})(_templateObject3(), PreviewButton, previewVisibleStyles);
var EmbedContainer = styled(AspectRatioBox).withConfig({
    componentId: "sc-8c66e08-3"
})(_templateObject4(), PreviewContainer, previewVisibleStyles);
var BoardEmbedPreview = function(props) {
    var boardKey = props.boardKey, imageSrc = props.imageSrc, imageName = props.imageName;
    var ref = useState(false), isEmbedVisible = ref[0], setEmbedVisible = ref[1];
    var t = useTranslation("common").t;
    return /*#__PURE__*/ _jsx(EmbedContainer, {
        "data-testid": "board-embed-preview-container",
        $width: 720,
        $height: 480,
        onClick: function() {
            setEmbedVisible(true);
        },
        children: isEmbedVisible ? /*#__PURE__*/ _jsx(BoardEmbed, {
            boardId: boardKey
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(NextImage, {
                    src: prefixUrl(imageSrc),
                    unoptimized: true,
                    alt: imageName,
                    priority: true,
                    layout: "fill"
                }),
                /*#__PURE__*/ _jsx(PreviewContainer, {
                    children: /*#__PURE__*/ _jsx(PreviewButton, {
                        children: /*#__PURE__*/ _jsxs(Box, {
                            $styles: {
                                display: "flex",
                                flexFlow: "row nowrap",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(PreviewIcon, {
                                    width: 24,
                                    height: 24
                                }),
                                t("templates-actions-preview")
                            ]
                        })
                    })
                })
            ]
        })
    });
};
export default BoardEmbedPreview;
